import { actionTypes } from 'actions/authenticate';

const initialState: IAuthenticateState = {
  token: null,
  email: null,
  setupAccountSuccess: null,
  updatePasswordSuccess: null,
  errorMessage: null,
  loginAfterIdle: false,
  profile: null,
};

export default function authenticate(
  state: IAuthenticateState = initialState,
  action: Action<any>,
): IAuthenticateState {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        email: action.payload.email,
      };
    case actionTypes.LOGIN_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case actionTypes.SETUP_ACCOUNT_SUCCESS:
      return {
        ...state,
        setupAccountSuccess: true,
      };
    case actionTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordSuccess: true,
      };
    case actionTypes.RESET_PASSWORD_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case actionTypes.UPDATE_LOGIN_AFTER_IDLE:
      return {
        ...state,
        loginAfterIdle: action.payload,
      };
    case actionTypes.GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
}
